import { Plugin } from '@ckeditor/ckeditor5-core';
import Templatesediting from './templatesediting';
import TemplatesUi from './templatesui';

export default class Templates extends Plugin {
    static get requires() {
        return [ Templatesediting,TemplatesUi ];
    }
}
